import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPreviewEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 172,
	height: 172,
	viewBox: "0 0 172 172",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 14,
			y: 33,
			width: 144,
			height: 10,
			rx: 5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14,
			y: 66,
			width: 144,
			height: 10,
			rx: 5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14,
			y: 99,
			width: 144,
			height: 10,
			rx: 5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.628 138.589L150.424 147.113C150.157 149.005 148.532 150.4 146.64 150.4H134.868C133.855 150.4 132.403 149.999 131.696 149.273L123 140.118L124.586 138.513C125.045 138.054 125.695 137.844 126.344 137.978L132.556 139.392V118.867C132.556 117.28 133.836 116 135.422 116C137.008 116 138.289 117.28 138.289 118.867V130.333H140.028C140.62 130.333 141.213 130.467 141.729 130.735L149.545 134.633C151.017 135.379 151.858 136.965 151.628 138.589Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconPreviewEmpty;
